(function() {
  // Guard to prevent multiple executions
  if (window.blindstyleSearchBySizeInitialized) return;
  window.blindstyleSearchBySizeInitialized = true;
  // console.log('Search by size script initialized');

  // Declare variables in a higher scope to be accessible by all functions
  let widthInput, heightInput, cmRadio, mmRadio, unitSpans;

  // Function to wait for an element to exist in the DOM
  function waitForElement(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        return;
      }

      const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
          observer.disconnect();
          resolve(document.querySelector(selector));
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

  // Helper function to calculate price from dimensions and pricing table
  function calculatePrice(width, height, pricingTable, isShutters, minWidth, maxWidth, minHeight, maxHeight) {
    try {
      // Convert dimensions to numbers (mm to nearest multiple of 50)
      width = Math.ceil(parseFloat(width) / 50) * 50;
      height = Math.ceil(parseFloat(height) / 50) * 50;
      
      // console.log('Calculated dimensions:', width, height);
      
      // Validate dimensions
      if (isNaN(width) || isNaN(height) || width <= 0 || height <= 0) {
        //console.log('Invalid dimensions');
        return null;
      }

      // Handle shutters (area-based pricing)
      if (isShutters) {
        // Validate against provided min/max dimensions
        if (width < minWidth || width > maxWidth || height < minHeight || height > maxHeight) {
          // console.log('Shutter dimensions out of bounds:', 
          //   `width ${width} (${minWidth}-${maxWidth}), `,
          //   `height ${height} (${minHeight}-${maxHeight})`);
          return null;
        }

        // Calculate area price (converting mm to cm for calculation)
        const widthCM = width / 10;
        const heightCM = height / 10;
        const areaPricingRate = 464.51;
        const price = (widthCM * heightCM / 10000) * areaPricingRate;
        // console.log('Calculated area price:', price);
        return price;
      }

      // Handle regular pricing table products
      if (!pricingTable) {
        // console.log('No pricing table provided');
        return null;
      }

      // Check if dimensions are within bounds before finding indices
      const tableMinWidth = pricingTable.widths[0];
      const tableMaxWidth = pricingTable.widths[pricingTable.widths.length - 1];
      const tableMinHeight = pricingTable.heights[0];
      const tableMaxHeight = pricingTable.heights[pricingTable.heights.length - 1];

      if (width < tableMinWidth || width > tableMaxWidth || height < tableMinHeight || height > tableMaxHeight) {
        // console.log('Dimensions out of bounds:', 
        //   `width ${width} (${tableMinWidth}-${tableMaxWidth}), `,
        //   `height ${height} (${tableMinHeight}-${tableMaxHeight})`);
        return null;
      }

      // Find indices in the width and height arrays
      const widthIndex = pricingTable.widths.findIndex(w => width <= w);
      const heightIndex = pricingTable.heights.findIndex(h => height <= h);

      // console.log('Indices:', widthIndex, heightIndex);

      // Get price from the price matrix
      const price = parseFloat(pricingTable.prices[heightIndex][widthIndex]);
      // console.log('Found price:', price);
      return isNaN(price) ? null : price;
    } catch (e) {
      console.warn('Error calculating price:', e);
      return null;
    }
  }

  function updateAllProductPrices() {
    const gridItems = document.querySelectorAll('.productitem--info');
    // console.log('Found grid items:', gridItems.length);

    // Get stored data first
    const storedData = JSON.parse(localStorage.getItem('lgxProductOptions') || '{}');
    
    // Use stored values
    const width = storedData.width?.value || storedData.Width?.value || '';
    const height = storedData.height?.value || storedData.Height?.value || '';
    const unit = storedData.Measurement?.value?.toLowerCase() || 'mm';

    if (width && height) {
      // Convert to mm for calculations if needed
      const widthMM = unit === 'cm' ? width * 10 : parseFloat(width);
      const heightMM = unit === 'cm' ? height * 10 : parseFloat(height);

      gridItems.forEach(item => {
        try {
          // Skip calculation if it's a skylight blind
          if (item.dataset.isSkylight === 'true') {
            return;
          }

          const isShutters = item.dataset.isShutters === 'true';
          const minWidth = parseInt(item.dataset.minWidth) || 0;
          const maxWidth = parseInt(item.dataset.maxWidth) || Infinity;
          const minHeight = parseInt(item.dataset.minHeight) || 0;
          const maxHeight = parseInt(item.dataset.maxHeight) || Infinity;
          
          const rawPricingTable = item.dataset.pricingTable;
          const pricingTable = JSON.parse(rawPricingTable || 'null');
          const allowsAddons = item.dataset.allowsAddons === 'true';
          
          const priceContainer = item.querySelector('.price__current .money');
          
          if (priceContainer) {
            const newPrice = calculatePrice(
              widthMM,
              heightMM,
              pricingTable?.template,
              isShutters,
              minWidth,
              maxWidth,
              minHeight,
              maxHeight
            );
            
            if (newPrice !== null) {
              const formattedPrice = newPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              
              const priceSpan = priceContainer.querySelector('.lgx-product-grid-price');
              if (priceSpan) {
                priceSpan.textContent = `£${formattedPrice}`;
                
                const fromSpan = priceContainer.querySelector('.prodFrom');
                if (fromSpan) {
                  fromSpan.style.display = allowsAddons ? 'inline' : 'none';
                }
                
                // Display dimensions in the user's chosen unit
                const dimensionsSpan = item.querySelector('.lgx-product-grid-dimensions');
                if (dimensionsSpan) {
                  const displayWidth = unit === 'cm' ? (widthMM / 10).toFixed(1) : Math.round(widthMM);
                  const displayHeight = unit === 'cm' ? (heightMM / 10).toFixed(1) : Math.round(heightMM);
                  dimensionsSpan.textContent = ` (${displayWidth}${unit} × ${displayHeight}${unit})`;
                }

                // Reset the ATC button text if it was previously changed
                const atcButton = item.querySelector('.atc-button--text');
                if (atcButton) {
                  atcButton.textContent = 'Choose Colour & Size';
                }
              }
            } else {
              // Size not available
              const dimensionsSpan = item.querySelector('.lgx-product-grid-dimensions');
              if (dimensionsSpan) {
                dimensionsSpan.textContent = ' (Not available in your size)';
              }
              
              // Update the ATC button text
              const atcButton = item.querySelector('.atc-button--text');
              if (atcButton) {
                atcButton.textContent = 'Try Another Size';
              }
            }
          }
        } catch (e) {
          console.warn('Error updating price:', e);
        }
      });

      if (window.productPriceObserver) {
        window.productPriceObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }
  }

  // Function to update units
  function updateUnits() {
    const unit = mmRadio.checked ? 'mm' : 'cm';
    unitSpans.forEach(span => span.textContent = unit);
  }

  // Function to initialize from storage
  function initializeFromStorage() {
    try {
      // First check URL parameters
      const urlParams = new URLSearchParams(window.location.search);
      const urlWidth = urlParams.get('width');
      const urlHeight = urlParams.get('height');
      const urlUnit = urlParams.get('unit');

      // Get stored data
      const storedData = JSON.parse(localStorage.getItem('lgxProductOptions') || '{}');

      // Set width (URL takes priority)
      if (urlWidth) {
        widthInput.value = urlWidth;
        storedData['Width'] = { value: urlWidth, additionalCost: 0 };
      } else if (storedData['Width']) {
        widthInput.value = storedData['Width'].value;
      }

      // Set height (URL takes priority)
      if (urlHeight) {
        heightInput.value = urlHeight;
        storedData['Height'] = { value: urlHeight, additionalCost: 0 };
      } else if (storedData['Height']) {
        heightInput.value = storedData['Height'].value;
      }

      // Set measurement unit (URL takes priority)
      const unit = urlUnit || storedData['Measurement']?.value?.toLowerCase() || 'mm';
      if (unit === 'cm') {
        cmRadio.checked = true;
        storedData['Measurement'] = { value: 'CM', additionalCost: 0 };
      } else {
        mmRadio.checked = true;
        storedData['Measurement'] = { value: 'MM', additionalCost: 0 };
      }

      // Update localStorage with potentially new values from URL
      localStorage.setItem('lgxProductOptions', JSON.stringify(storedData));

      updateUnits();
    } catch (e) {
      console.warn('Error initializing from storage:', e);
    }
  }

  // Main initialization function
  async function initSearchBySize() {
    // console.log('Initializing search by size');
    // Wait for the search form to exist
    const form = await waitForElement('.search-by-size');
    // console.log('Form found:', form);
    if (!form) return;

    mmRadio = document.getElementById('search-by-size-measurement-mm');
    cmRadio = document.getElementById('search-by-size-measurement-cm');
    widthInput = document.getElementById('width');
    heightInput = document.getElementById('height');
    unitSpans = document.querySelectorAll('.search-by-size__unit');
    const searchButton = document.querySelector('.search-by-size__button');

    // Initialize with stored values if they exist
    initializeFromStorage();

    function convertValue(value, fromMM) {
      if (!value) return '';
      const num = parseFloat(value);
      if (fromMM) {
        // Converting from mm to cm
        return (num / 10).toFixed(2);
      } else {
        // Converting from cm to mm
        return Math.round(num * 10).toString();
      }
    }

    function updateLocalStorage() {
      try {
        const existingData = JSON.parse(localStorage.getItem('lgxProductOptions') || '{}');

        existingData['Width'] = {
          value: widthInput.value,
          additionalCost: 0
        };
        existingData['Height'] = {
          value: heightInput.value,
          additionalCost: 0
        };
        existingData['Measurement'] = {
          value: document.querySelector('#search-by-size-measurement-cm').checked ? 'CM' : 'MM',
          additionalCost: 0
        };

        localStorage.setItem('lgxProductOptions', JSON.stringify(existingData));

        // Update URL without refresh, but use debouncing
        clearTimeout(window.urlUpdateTimeout);
        window.urlUpdateTimeout = setTimeout(() => {
          const unit = document.querySelector('#search-by-size-measurement-cm').checked ? 'cm' : 'mm';
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set('width', widthInput.value);
          newUrl.searchParams.set('height', heightInput.value);
          newUrl.searchParams.set('unit', unit);
          history.pushState({}, '', newUrl);
        }, 500); // Wait 500ms after last keystroke before updating URL

        // Always update prices immediately
        updateAllProductPrices();
      } catch (e) {
        console.warn('Error writing to localStorage:', e);
      }
    }

    // Event Listeners
    mmRadio.addEventListener('change', function() {
      if (this.checked) {
        widthInput.value = convertValue(widthInput.value, false);
        heightInput.value = convertValue(heightInput.value, false);
        updateUnits();
        updateLocalStorage();
      }
    });

    cmRadio.addEventListener('change', function() {
      if (this.checked) {
        widthInput.value = convertValue(widthInput.value, true);
        heightInput.value = convertValue(heightInput.value, true);
        updateUnits();
        updateLocalStorage();
      }
    });

    // Update localStorage when dimensions change
    widthInput.addEventListener('input', updateLocalStorage);
    heightInput.addEventListener('input', updateLocalStorage);

    searchButton.addEventListener('click', function() {
      if (!widthInput.value || !heightInput.value) {
        return;
      }

      const unit = mmRadio.checked ? 'mm' : 'cm';

      // Get current path and check if it's a collection
      const currentPath = window.location.pathname;
      const isCollection = currentPath.startsWith('/collections/');

      if (isCollection) {
        // On collection pages, close the modal properly
        const modal = document.querySelector('.lgx-search-by-size-modal');
        if (modal) {
          modal.style.display = 'none';
          document.body.style.overflow = ''; // Re-enable scrolling
        }
      } else {
        // On non-collection pages or /collections/all, redirect with parameters
        const baseUrl = '/collections/all';
        window.location.href = `${baseUrl}?width=${widthInput.value}&height=${heightInput.value}&unit=${unit}`;
      }
    });

    // We no longer need to call initializeFromStorage and updateAllProductPrices here
    // as they are called in the main IIFE scope and via event listeners.
  }

  // Add CSS for the dimensions display
  const style = document.createElement('style');
  style.textContent = `
    .product-dimensions {
      font-size: 0.9em;
      color: #666;
      white-space: nowrap;
    }
    .product-dimensions--invalid {
      color: #dc3545;
    }
  `;
  document.head.appendChild(style);

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchBySize);
  } else {
    initSearchBySize();
  }

  // Store observer reference globally so we can disconnect/reconnect it
  window.productPriceObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if any of the added nodes are product items or contain product items
        const hasNewProducts = Array.from(mutation.addedNodes).some(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            return node.classList?.contains('productitem--info') ||
                   node.querySelector?.('.productitem--info');
          }
          return false;
        });

        if (hasNewProducts) {
          updateAllProductPrices();
        }
      }
    }
  });

  window.productPriceObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also add URL parameter handling to the window popstate event
  window.addEventListener('popstate', function(event) {
    // Ensure that elements are defined before attempting to use them
    if (widthInput && heightInput && cmRadio && mmRadio && unitSpans) {
      initializeFromStorage();
      updateAllProductPrices();
    } else {
      // If elements are not yet defined (e.g., popstate fires very early), re-run init
      initSearchBySize();
    }
  });
})();